<template>
  <header class="navbar">
    <div class="navbar-inner">
      <div class="navbar-left" @click="goHome">
        <img class="logo-mark" src="@/assets/logo.svg" alt="壹零壹陆 Logo">
        <div class="logo-text">
          <div class="logo-title">壹零壹陆</div>
          <div class="logo-subtitle">南京壹零壹陆信息科技</div>
        </div>
      </div>
      <nav class="navbar-right">
        <router-link
          v-for="item in menus"
          :key="item.path"
          :to="item.path"
          exact
          class="nav-item"
          active-class="nav-item--active"
        >
          {{ item.label }}
        </router-link>
      </nav>
      <button class="nav-toggle" type="button" @click="toggleMobile">
        <span></span>
        <span></span>
      </button>
    </div>
    <transition name="nav-slide">
      <div v-if="mobileOpen" class="navbar-mobile">
        <router-link
          v-for="item in menus"
          :key="item.path"
          :to="item.path"
          exact
          class="nav-item-mobile"
          active-class="nav-item-mobile--active"
          @click.native="mobileOpen = false"
        >
          {{ item.label }}
        </router-link>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      mobileOpen: false,
      menus: [
        { path: '/', label: '首页' },
        { path: '/news', label: '保险信息' },
        { path: '/industry', label: '行业资讯' },
        { path: '/service', label: '在线客服' },
        { path: '/contact', label: '联系我们' }
      ]
    }
  },
  methods: {
    goHome() {
      if (this.$route.path === '/') return
      this.$router.push('/').catch(() => {})
    },
    toggleMobile() {
      this.mobileOpen = !this.mobileOpen
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #dbe4f0;
  box-shadow: 0 4px 16px rgba(14, 116, 180, 0.06);
}

.navbar-inner {
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
}

.navbar-left {
  display: flex;
  align-items: center;
  cursor: pointer;
  min-width: 0;
}

.logo-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  object-fit: cover;
  margin-right: 12px;
  flex-shrink: 0;
}

.logo-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.logo-title {
  font-size: 20px;
  color: #0284c7;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.15;
}

.logo-subtitle {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-item {
  font-size: 14px;
  color: #475569;
  padding: 8px 14px;
  border-radius: 999px;
  transition: color 0.2s ease, background 0.2s ease;
}

.nav-item:hover {
  color: #0284c7;
  background: #e0f2fe;
}

.nav-item--active {
  color: #0284c7;
  background: #e0f2fe;
  font-weight: 600;
}

.nav-toggle {
  display: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #cfe0f0;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.nav-toggle span {
  display: block;
  width: 16px;
  height: 2px;
  background: #0284c7;
  margin: 2px 0;
}

.navbar-mobile {
  display: none;
}

.nav-slide-enter-active,
.nav-slide-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.nav-slide-enter,
.nav-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

@media (max-width: 768px) {
  .navbar-right { display: none; }
  .nav-toggle { display: inline-flex; }
  .logo-subtitle { display: none; }

  .navbar-mobile {
    display: flex;
    flex-direction: column;
    padding: 4px 16px 12px;
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
  }

  .nav-item-mobile {
    padding: 12px 0;
    font-size: 14px;
    color: #475569;
    border-bottom: 1px solid #f1f5f9;
  }

  .nav-item-mobile--active {
    color: #0284c7;
    font-weight: 600;
  }
}
</style>
